import { render, staticRenderFns } from "./UpSelling.vue?vue&type=template&id=3dd9bc66"
import script from "./UpSelling.vue?vue&type=script&lang=js"
export * from "./UpSelling.vue?vue&type=script&lang=js"
import style0 from "./UpSelling.vue?vue&type=style&index=0&id=3dd9bc66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports